import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { ReactComponent as DateIcon } from '../assets/images/icons/date_icon_one.svg'
import { ReactComponent as Logo } from '../assets/images/logo.svg';
import './auth.scss';
import ReactDatePicker from 'react-datepicker';
import { Input } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css'
import moment from 'moment'
import { getUserId, setToken, setUserId } from '../helper/helper';
import { addUserDetailsApiFun } from '../API/Services/authService';
import { RouterConstant } from '../constants/RouteConstant';
import LoaderWrapper from '../Components/LoaderWrapper/LoaderWrapper';
import { useAlert } from 'react-alert';
import authBg from '../assets/images/background/auth-bg.png';
import { GlobalContext } from '../globalContext';

const AddUserDetails = () => {
  let navigate = useNavigate()
  const alert = useAlert();
  const [loader, setLoader] = useState(false);
  const { setUrlReferral,urlReferral } = React.useContext(GlobalContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();
  const handleAddUserDetails = (formData) => {
    setLoader(true)
    const userId = getUserId()
    const date = moment(formData.dob).format('DD/MM/YYYY')

    // Base payload
    const data = {
      userId: userId,
      dob: date,
      gender: formData.gender.toLowerCase(),
      isAgreeWithTNC: formData.checkTerms,
    };

    // Add optional referralCode only if provided (non-empty)
    if (formData.referralCode && String(formData.referralCode).trim().length > 0) {
      data.referalCode = String(formData.referralCode).trim();
    }

    addUserDetailsApiFun(data)
      .then(response => {
        setLoader(false)
        if (response?.data?.status === 'OK') {
          alert.success(response?.data?.message)
          setToken(response?.data?.data?.token)
          setUserId(response?.data?.data?.userId)
          navigate(RouterConstant.success)
        } else {
          console.log(response)
        }
      })
      .catch(error => {
        console.log(error)
        setLoader(false)
        alert.error(error?.message)
      })
  }

  return (
    <>
      <div className="auth-wrapper" style={{ backgroundImage: `url(${authBg})` }}>
        <div className="auth-inner-wrapper">
          <div className="auth-header">
            <div className="logo-wrapper mb-5 mb-md-0">
              <Logo className="logo-icon mb-5 mb-md-0" />
            </div>
          </div>

          <form className="form-wrapper" onSubmit={handleSubmit(handleAddUserDetails)}>
            {/* DOB */}
            <div className="input-wrapper">
              <Controller
                render={({ field: { onChange, value } }) => (
                  <ReactDatePicker
                    showPopperArrow={false}
                    className={`form-control input-box ${errors.dob ? "not-valid" : ""}`}
                    dateFormat="dd/MM/yyyy"
                    selected={value}
                    onChange={onChange}
                    placeholderText="Date of birth"
                    maxDate={new Date()}
                    showYearDropdown
                    dropdownMode="select"
                    scrollableYearDropdown
                  />
                )}
                control={control}
                name="dob"
                rules={{ required: "Please fill your Dob" }}
              />
              <DateIcon className="input-icon d-block d-md-none" />
              {errors.dob && errors.dob.type === "required" && (
                <small className="error-msg">Please fill your Dob</small>
              )}
            </div>

            {/* Gender */}
            <div className="input-wrapper">
              <Controller
  name="gender"
  control={control}
  defaultValue="" // important for RHF
  rules={{ required: "Please select your gender" }}
  render={({ field: { onChange, value } }) => (
    <Input
      type="select"
      id="gender"
      value={value}
      onChange={onChange}
      className={`form-control input-box ${errors.gender ? "not-valid" : ""}`}
      style={{ color: value ? "#000" : "#A1A1A1" }}
    >
      <option value="Select Gender" >Select Gender</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Other">Other</option>
    </Input>
  )}
/>

              {errors.gender && errors.gender.type === "required" && (
                <small className="error-msg">Please select your gender</small>
              )}
            </div>

            {/* Referral Code (optional) */}
            <div className="input-wrapper">
              <label>Referral Code (optional)</label>
              <input
                type="text"
                className={`form-control input-box ${errors.referralCode ? "not-valid" : ""}`}
                value={urlReferral?urlReferral:''}
                id="referralCode"
                placeholder="Enter referral code"
                {...register('referralCode')}
              />
              {/* No error message since optional */}
            </div>

            {/* Terms & Conditions */}
            <div className="input-wrapper check-terms text-md-center">
              <input
                type="checkbox"
                id="checkTerms"
                {...register('checkTerms', { required: true })}
                name="checkTerms"
                value="true"
              />
              <label htmlFor="checkTerms">
                {' '}I agree to the <span className="heighlight">{`Terms & Conditions`}</span>
              </label>
              {errors.checkTerms && errors.checkTerms.type === "required" && (
                <small className="error-msg">you need to agree to our T&C inorder to proceed</small>
              )}
            </div>

            <div className="text-center submit w-100">
              <button type="submit" className="btn primary-btn w-100">Finish</button>
            </div>
          </form>
        </div>
      </div>

      {loader ? <LoaderWrapper /> : ''}
    </>
  )
}

export default AddUserDetails
